export default {
  labels: {
    pickup_time: 'Abholzeit',
    on_site_time: 'Servierzeit',
    delivery_time: 'Lieferzeit',
    today: 'Heute',
  },
};
